import { GlobalState } from '@leverege/ui-redux';
function deleteAll(actions, childPath, items, opts) {
  const {
    setProgress
  } = opts;
  let cancelled = false;
  const run = () => {
    return GlobalState.dispatch(async (dispatch, getState, {
      api
    }) => {
      const childApi = api.child(`v1/interface/${actions.child(childPath).getInterfaceUrl()}`);
      for (let i = 0; i < items.length; i++) {
        if (cancelled) {
          return true;
        }
        await childApi.child(items[i].id).delete({
          deleteDevice: 'force'
        });
        setProgress(i + 1);
      }
      return cancelled;
    });
  };
  const cancel = () => {
    cancelled = true;
  };
  return {
    toAwait: run(),
    cancel
  };
}
function deleteZones(locationActions, zones, opts) {
  const {
    setZonesDeleted
  } = opts;
  return deleteAll(locationActions, 'zones', zones, {
    setProgress: setZonesDeleted
  });
}
function deleteVehicles(locationActions, vehicles, opts) {
  const {
    setVehiclesDeleted
  } = opts;
  return deleteAll(locationActions, 'vehicles', vehicles, {
    setProgress: setVehiclesDeleted
  });
}
async function getAll(listActions) {
  const list = [];
  const limit = 1000;
  let offset = 0,
    total;
  do {
    // eslint-disable-next-line no-await-in-loop
    const res = await listActions.get({
      limit,
      offset
    });
    list.push(...(res.items || []));
    total = res.total;
    offset += limit;
  } while (offset < total);
  return list;
}
function getAllZones(locationActions) {
  return GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    return getAll(api.child(`v1/interface/${locationActions.child('zones').getInterfaceUrl()}`));
  });
}
function getAllVehicles(locationActions) {
  return GlobalState.dispatch(async (dispatch, getState, {
    api
  }) => {
    return getAll(api.child(`v1/interface/${locationActions.child('vehicles').getInterfaceUrl()}`));
  });
}
export default {
  getAllVehicles,
  getAllZones,
  deleteVehicles,
  deleteZones
};